import { BeMenuField, BeStack } from "@beos-css/react/index.ts";

export function MenuFieldDemo() {
	return (
		<section id="demo-menu-field">
			<h2>Menu field / dropdown (BMenuField)</h2>
			<p>
				The R5 well is a two-layer composite, all decomp-sourced: the BMenuField flat #98 frame (#60 TR/BL pips, notched corners) around the
				_BMCMenuBar_'s own B_BORDER_CONTENTS bevel (#ef light, #60 dark, #b8 inner) — together they form the classic raised look. The #60
				pop-up marker (top edge at bar center + 1) is from _BMCItem_::Draw. Only the closed control is themed; the open list is still native
				OS chrome until the customizable-select API (appearance: base-select) ships broadly.
			</p>
			<BeStack gap="label" align="start">
				<BeMenuField label="Connect to:" defaultValue="primary">
					<option value="primary">primary</option>
					<option value="work">work</option>
					<option value="home">home</option>
				</BeMenuField>
				<BeMenuField label="From location:" defaultValue="home">
					<option value="home">Home</option>
					<option value="office">Office</option>
				</BeMenuField>
				<BeMenuField label="Disabled:" defaultValue="primary" disabled>
					<option value="primary">primary</option>
				</BeMenuField>
			</BeStack>
		</section>
	);
}
